import React from 'react';
import { Footer2, Navbar2 } from './C_Mobile.jsx';

function Careers() {
    return (
        <div className='fixed-top set_background' style={{ maxHeight: '100vh', overflowY: 'scroll', color: 'white' }}>
            <Navbar2 />
            <div style={{ color: 'white', margin: '3rem', marginLeft: '5%', marginRight: '5%' }}>
                <div className="row">
                    <div className="col-md-6">
                        <h2><strong>Join Our Team at The Lobby Barbershop!</strong></h2>
                        <p><strong>Are you passionate about helping others look and feel their best?</strong> Do you have a keen eye for style and creativity, and want to build a successful career in the beauty and grooming industry? If so, we’d love to meet you!</p>
                        <p>At The Lobby Barbershop, we offer a vibrant and supportive environment where you can grow both your practical skills and creative talents. Whether you're starting your career or looking to take it to the next level, we provide an exciting platform to showcase your expertise while working with a team of professionals who share your passion.</p>
                        <h2><strong>Why The Lobby Barbershop?</strong></h2>
                        <p>We pride ourselves on creating an inclusive and positive atmosphere for both our clients and team members. As a part of our team, you'll have the chance to develop your skills in:</p>
                        <ul>
                            <li><strong>Barbering & Hairstyling</strong></li>
                            <li><strong>Hairdressing</strong></li>
                            <li><strong>Salon Management</strong></li>
                        </ul>
                        <p>We believe in nurturing your growth, whether you're perfecting your craft behind the chair or helping manage the day-to-day operations of the salon.</p>
                        <h2><strong>Ready to Join Us?</strong></h2>
                        <p>If you're motivated, passionate, and ready to take your career to new heights, The Lobby Barbershop is the perfect place for you.</p>
                        <p>Fill out the form below with your contact details and profile to apply for upcoming positions. We look forward to hearing from you and seeing how you can make a difference at The Lobby!</p>
                    </div>

                    <div className="col-md-6">
                        <h2>APPLY HERE</h2>
                       
                        <form action="https://formsubmit.co/info@thelobbybarbershop.ca" method="POST">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Your name *</label>
                                <input type="text" name='name' className="form-control" id="name" style={{ background: 'transparent', color: 'white' }} required />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Your e-mail address *</label>
                                <input type="email" name="email" className="form-control" id="email" style={{ background: 'transparent', color: 'white' }} required />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="phone" className="form-label">Your phone number *</label>
                                <input type="tel" name="phone" className="form-control" id="phone" style={{ background: 'transparent', color: 'white' }} required />
                            </div>
                            {/* <div className="mb-3">
                                <label htmlFor="resume" className="form-label">Online resume URL *</label>
                                <input type="url" name="resume" className="form-control" id="resume" style={{ background: 'transparent', color: 'white' }} required />
                            </div> */}
                            <div className="mb-3">
                                <label htmlFor="message" className="form-label">Message *</label>
                                <textarea name="Message" className="form-control" id="message" rows="3" style={{ background: 'transparent', color: 'white' }} required></textarea>
                            </div>
                            <br></br>
                            <button type="submit" className="btn btn-warning" style={{width: '100%'}}>SEND</button>
                        </form>
                    </div>
                </div>
            </div>
            <Footer2 />
        </div>
    );
}

export default Careers;